import { ReactNode, createContext, useContext } from 'react';
import usePostPartnerAccount from '../hooks/useApi/usePostPartnerAccount';

import type { PartnerAccountRequest, PartnerAccountResponse } from '../hooks/useApi/usePostPartnerAccount';

type PartnerAccountCtx = {
  response: PartnerAccountResponse | undefined;
  postPartnerAccount: (requestParams: PartnerAccountRequest) => void;
  reset: () => void;
};

const defaultData = {
  success: false,
  errorMessage: '',
  accountId: '',
  apiSharedSecret: '',
  apiKey: '',
  message: '',
  onboardingLink: '',
};

export const PartnerAccountContext = createContext<PartnerAccountCtx>({
  response: defaultData,
  postPartnerAccount: () => {},
  reset: () => {},
});

export const PartnerAccountProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const [response, postPartnerAccount, reset] = usePostPartnerAccount({});

  return (
    <PartnerAccountContext.Provider
      value={{
        response,
        postPartnerAccount,
        reset,
      }}
    >
      {children}
    </PartnerAccountContext.Provider>
  );
};

export const usePartnerAccount = (): PartnerAccountCtx => useContext(PartnerAccountContext);
